import {Component, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {Centre} from "../../../../interfaces/Centres";
import {MatTableDataSource} from "@angular/material/table";
import {ChildService} from "../../../../components/child/child.service";
import {CentreService} from "../../../../services/centre.service";
import {Subject, takeUntil} from "rxjs";
import {FullChild} from "../../../../interfaces/FullChild";

import {map} from "rxjs/operators";
import {AdmissionType} from "../../../../interfaces/AdmissionType";
import * as XLSX from "xlsx";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {FinancialYearService} from "../../../../services/financial-year.service";

export interface WeeklyReport {

  centreName: string
  centreCode: string
  totalRooms: number
  Occupied: number
  OccupiedEnd: number
  Available: number
  Occupancy: number
  uniqueAdmission: number
  followUpAdmission: number
  uniqueDischarge: number
  followupDischarge: number
  os: number
  dama: number
  alwaysChamp: number
  centre: Centre

}

@Component({
  selector: 'app-weekly-reports',
  templateUrl: './weekly-reports.component.html',
  styleUrls: ['./weekly-reports.component.scss']
})
export class WeeklyReportsComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  startDate1!: Date
  endDate1!: Date
  admittedList: string[] = []
  isLoading = false;  // New loading flag
  dataSource!: MatTableDataSource<WeeklyReport>;
  // displayedColumns: String[] = ['centername', 'totalunits', 'occupiedunits', 'occupiedunitsEnd', 'difference', 'percentage'];
  displayedColumns: String[] = ['centername', 'totalunits', 'occupiedunits',  'occupiedunitsEnd', 'difference', 'percentage', ];
  allCentres: Centre[] = [];
  mCentres: Centre[] = [];
  mWeekly: WeeklyReport[] = [];
  pCOUNT = 0
  pCOUNT2 = 0
  pList: string[] = []
  pList2: string[] = []
  fileName = 'Weekly_Report.xlsx';

  centreSelectionArray = [
    {
      centreName: 'All Centres',
      centreCode: 'All'
    },
    {
      centreName: 'AL Bandra',
      centreCode: 'ALBandra'
    },
    {
      centreName: 'AL Ahmedabad',
      centreCode: 'ALAhmedabad'
    },
    {
      centreName: 'AL Bangalore',
      centreCode: 'ALBangalore'
    }, {
      centreName: 'AL Borivali',
      centreCode: 'ALBorivali'
    },
    {
      centreName: 'AL Chandigarh',
      centreCode: 'ALChandigarh'
    }, {
      centreName: 'AL Gurunanak Niwas',
      centreCode: 'ALGurunanak'
    },
    {
      centreName: 'AL Diamond Garden',
      centreCode: 'ALDiamondGarden'
    },
    {
      centreName: 'AL Manipal',
      centreCode: 'ALManipal'
    }, {
      centreName: 'AL Pune',
      centreCode: 'ALPune'
    },
    {
      centreName: 'AL Sandu Garden',
      centreCode: 'ALSanduGarden'
    },

  ]

  totalUnits = 0
  totalOccupiedUnits = 0
  totalAvailableUnits = 0
  mAllChild: FullChild[] = []
  mSortedChild: FullChild[] = []
  _destroyed$ = new Subject()
  showLog = false

  constructor(
    private readonly mChildService: ChildService,
    private readonly mCenterService: CentreService,
    private  readonly mFirestore:AngularFirestore,
    private readonly financialYearService: FinancialYearService,
  ) {
    //*To check alloted list by registration log in child admission
    // this.mChildService.allotedChildRegistrationbyCenter('Staying','ALGurunanak').subscribe(res=>{this.admittedList = res.map(x=>x.childCode)})
  }

  clearAll() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate1 = fy.startDate;
    this.endDate1 = fy.endDate;
    this.mWeekly = [];
    this.dataSource = new MatTableDataSource<WeeklyReport>([]);
  }


  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate1 = fy.startDate;
    this.endDate1 = fy.endDate;
    // if (this.mAllChild.length == 0) this.mChildService.getLatestData().pipe(takeUntil(this._destroyed$),
    //   map(x => x.docs.map(y => y.data())
    //   )
    // ).subscribe(res => {
    //   this.mAllChild = res
    //   console.log("this.mAllChild", this.mAllChild)
    //   this.mSortedChild = this.mAllChild
    //
    // })
    this.initAllCentresData('All')

  }


  private initAllCentresData(centreCode: string) {
    console.log('getAllCentre Called with:', centreCode);

    if (centreCode === 'All') {
      // At startup when centreCode == "All"
      if (this.allCentres.length === 0) {
        this.mCenterService.getAllCentres().pipe(takeUntil(this._destroyed$)).subscribe(centres => {
          this.allCentres = centres;
          this.allCentres = centres.filter(x => x.centreCode != 'ALBandra')
          console.log('CENTRE LIST TABLE', centres);
          this.calculateTotalUnits();
          // Uncomment the following lines if needed
          // this.addExtraRowToOccupancyTable(this.totalUnits, this.totalAvailableUnits, this.totalOccupiedUnits, 'Total');
          // this.dataSource.paginator = this.paginator;
          // this.getTotalUnitsCount(this.allCentres);
        });
      }
      console.log('allCentres if', this.allCentres.length);
    } else if (centreCode !== 'All') {
      console.log('Into getAllCentresData with centreCode ==', centreCode);
      this.mCentres = this.allCentres.filter(c => c.centreCode === centreCode);
      console.log('CENTRE LIST TABLE', this.mCentres);

      this.calculateTotalUnits();
      // Uncomment the following lines if needed
      // this.addExtraRowToOccupancyTable(this.totalUnits, this.totalAvailableUnits, this.totalOccupiedUnits, 'Total');
      this.dataSource = new MatTableDataSource(this.mWeekly);
      // this.dataSource.paginator = this.paginator;
      // this.getTotalUnitsCount(this.allCentres);

      // console.log('allCentres else', this.allCentres.length);
    }
  }

  private calculateTotalUnits() {
    this.totalUnits = 0;
    this.totalAvailableUnits = 0;
    this.totalOccupiedUnits = 0;

    this.allCentres.forEach(c => {
      this.totalUnits += +c.totalUnits!;
      this.totalAvailableUnits += +c.availableUnits!;
      this.totalOccupiedUnits += +c.occupiedUnits!;
    });
  }


  ngOnDestroy(): void {
    this._destroyed$.next(null)
    this._destroyed$.complete()
  }

  getPercentage(element: Centre) {
    if (element.totalUnits != null && element.occupiedUnits != null) {
      let total = element.totalUnits
      let available = element.occupiedUnits
      let percentage = ((available / total) * 100)
      return percentage.toFixed(2)
    }
    return ''
  }

  getUniqueAdmissions(centreCode: string) {
    let uniqueAdmission = this.mAllChild.filter((x, i) => x.centreCode === centreCode)
    return uniqueAdmission.length
  }

  calculateByCentre(centreName: string, centreCode: string, startDate: Date, endDate: Date) {
    this.pList = [];
    this.pList2 = [];
//?Getting current centre
    const currentCenter = this.allCentres.find(x => x.centreCode === centreCode);
    if (!currentCenter) {
      console.log('Centre not found:', centreCode);
      return;

    }

    const admission: FullChild[] = [];
    const discharge: FullChild[] = [];
    let firstAdmission = 0;
    let firstDischarge = 0;
    let admissionCount = 0;
    let dischargeCount = 0;
    this.pCOUNT = 0;
    this.pCOUNT2 = 0;
    const oscount = this.mAllChild.filter(child => {
      // Check if the status is 'OM SHANTI'
      const isOMSHANTI = child.status === 'OM SHANTI';

      // Check if the admission date falls within the specified range
      const admissionDate = child.admissionData[0]?.dateOfAdmission?.toDate();
      const isWithinRange = admissionDate && admissionDate >= this.startDate1 && admissionDate <= this.endDate1;

      // Check if the center code matches the current center being processed
      const isSameCentre = child.centreCode === centreCode;

      // Return true if all conditions are met
      return isOMSHANTI && isWithinRange && isSameCentre;
    }).length;


    const damacount = this.mAllChild.filter(child => {
      // Check if the status is 'OM SHANTI'
      const isOMSHANTI = child.status === 'DAMA';

      // Check if the admission date falls within the specified range
      const admissionDate = child.admissionData[0]?.dateOfAdmission?.toDate();
      const isWithinRange = admissionDate && admissionDate >= this.startDate1 && admissionDate <= this.endDate1;

      // Check if the center code matches the current center being processed
      const isSameCentre = child.centreCode === centreCode;

      // Return true if all conditions are met
      return isOMSHANTI && isWithinRange && isSameCentre;
    }).length;


    //const oscount = this.mAllChild.filter(child => child.centreCode === centreCode && child.status === 'OM SHANTI').length;
    //const damacount = this.mAllChild.filter(child => child.centreCode === centreCode && child.status === 'DAMA').length;
    //Whose unique admissions is before the date
    const totalAdmissionsBeforeDate1 = this.mAllChild.filter(x => x.admissionData[0]?.dateOfAdmission?.toDate()! <= startDate); //?Total children admitted before date1
    const totalAdmissionsBeforeDate2 = this.mAllChild.filter(x => x.admissionData[0]?.dateOfAdmission?.toDate()! <= endDate); //?Total children admitted before date2

    console.log('TOTAL PREVIOUS ADMISSIONS BEFORE DATE 1', totalAdmissionsBeforeDate1.length);

    totalAdmissionsBeforeDate1.forEach(child => {
      // if (child.centreCode === centreCode) {
        child.admissionData.forEach((ad, i) => {
          this.checkPreviousAdmissionNew(i, ad, child.admissionData, this.pCOUNT, child.childCode,centreCode);
        });
      // }
    });

    totalAdmissionsBeforeDate2.forEach(child => {
      if (child.centreCode === centreCode) {
        child.admissionData.forEach((ad, i) => {
          this.checkPreviousAdmission2(i, ad, child.admissionData, this.pCOUNT2, child.childCode,centreCode);
        });
      }
    });

    this.mAllChild.forEach(child => {
     try {
        child.admissionData.forEach((ad, index) => {
          if (index === 0) {
            if (child.dateOfAdmission.toDate() >= startDate && child.dateOfAdmission?.toDate() <= endDate && ad.centreCode === centreCode) {
              firstAdmission++;
            }
          }

          if (index === 1) {
            if (ad.dateOfDischarge?.toDate()! >= startDate && ad.dateOfDischarge?.toDate()! <= endDate && ad.centreCode === centreCode) {
              firstDischarge++;
            }
          }

          if (index >= 2 && index % 2 === 0) {
            const d = ad.dateOfAdmission?.toDate()!;
            if (d > startDate && d < endDate && ad.centreCode === centreCode) {
              admissionCount++;
            }
          }

          if (index > 2 && index % 2 !== 0) {
            const d = ad.dateOfDischarge?.toDate()!;
            if (d > startDate && d < endDate && ad.centreCode === centreCode) {
              dischargeCount++;
            }
          }
        });
      }catch (e){
       console.log(`ERROR DUE TO ${child.childCode}  `,e)
     }

    });

    console.log('finalPrevCount', this.pCOUNT);
    console.table(this.pList);
    console.table(this.pList2);
    const mCurrenctCentreTotalUnits = currentCenter.totalUnits!
    const totalStayingStart = this.pCOUNT;
    const totalStayingEnd = this.pCOUNT2;
    currentCenter.occupiedUnits = totalStayingEnd;

    const report: WeeklyReport = {
      centre: currentCenter,
      centreName: centreName,
      centreCode: centreCode,
      totalRooms: mCurrenctCentreTotalUnits,
      Occupied: totalStayingStart,
      OccupiedEnd: totalStayingEnd,
      Available: mCurrenctCentreTotalUnits - totalStayingStart,
      Occupancy: +this.getPercentage(currentCenter),
      uniqueAdmission: firstAdmission,
      uniqueDischarge: firstDischarge,
      followUpAdmission: admissionCount,
      followupDischarge: dischargeCount,
      os: oscount,
      dama: damacount,
      alwaysChamp: 0
    };

    this.mWeekly.push(report);
  }


  // SearchData() {
  //   this.isLoading = true;  // New loading flag
  //   this.mWeekly = []
  //   // this.getDataWithinRange('AL Ahmedabad', 'ALAhmedabad', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL Ahmedabad', 'ALAhmedabad', this.startDate1, this.endDate1)
  //   // this.calculateByCentre('AL Bandra', 'ALBandra', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL Bangalore', 'ALBangalore', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL Borivali', 'ALBorivali', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL Chandigarh', 'ALChandigarh', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL Coimbatore', 'ALCoimbatore', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL Diamond Garden', 'ALDiamondGarden', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL Gurunanak Niwas', 'ALGurunanak', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL Madurai', 'ALMadurai', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL Manipal', 'ALManipal', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL Pune', 'ALPune', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL  Sandu Garden', 'ALSanduGarden', this.startDate1, this.endDate1)
  //   this.calculateByCentre('AL Silchar', 'ALSilchar', this.startDate1, this.endDate1)
  //   this.dataSource = new MatTableDataSource(this.mWeekly);
  //   this.isLoading = false;  // New loading flag
  // }

  SearchData() {
    this.isLoading = true;

    if (this.mAllChild.length === 0) {
      // ✅ Only fetch if not already loaded
      this.mChildService.getLatestData()
        .pipe(takeUntil(this._destroyed$), map(x => x.docs.map(y => y.data())))
        .subscribe(res => {
          this.mAllChild = res;
          console.log("this.mAllChild", this.mAllChild);
          this.mSortedChild = this.mAllChild;
          this.runCalculations();
        });
    } else {
      this.runCalculations();
    }
  }

  private runCalculations(): void {
    this.mWeekly = [];
    this.calculateByCentre('AL Ahmedabad', 'ALAhmedabad', this.startDate1, this.endDate1);
    this.calculateByCentre('AL Bangalore', 'ALBangalore', this.startDate1, this.endDate1);
    this.calculateByCentre('AL Borivali', 'ALBorivali', this.startDate1, this.endDate1);
    this.calculateByCentre('AL Chandigarh', 'ALChandigarh', this.startDate1, this.endDate1);
    this.calculateByCentre('AL Coimbatore', 'ALCoimbatore', this.startDate1, this.endDate1);
    this.calculateByCentre('AL Diamond Garden', 'ALDiamondGarden', this.startDate1, this.endDate1);
    this.calculateByCentre('AL Gurunanak Niwas', 'ALGurunanak', this.startDate1, this.endDate1);
    this.calculateByCentre('AL Madurai', 'ALMadurai', this.startDate1, this.endDate1);
    this.calculateByCentre('AL Manipal', 'ALManipal', this.startDate1, this.endDate1);
    this.calculateByCentre('AL Pune', 'ALPune', this.startDate1, this.endDate1);
    this.calculateByCentre('AL  Sandu Garden', 'ALSanduGarden', this.startDate1, this.endDate1);
    this.calculateByCentre('AL Silchar', 'ALSilchar', this.startDate1, this.endDate1);
    this.dataSource = new MatTableDataSource(this.mWeekly);
    this.isLoading = false;
  }

  getDataWithinRange(
    centreName: string, centreCode: string, startDate: Date, endDate: Date
  ) {
    //? First we need no of staying children on day1 i.e. start date and day 2 i.e. endDate
    //? So for day1 we need children which are admitted before start date and exclude those which are discharged before start date
this.mFirestore.collection(this.env.admissionLogs,ref =>
  //Admitted before date
  ref.where('dateOfDischarge', '<=', this.startDate1),


)

    //first we are going to get all admissions between the range
  }


  checkPreviousAdmission(i: number, ad: AdmissionType, data: AdmissionType[], prevcount: number, childCode: string) {
    try {
      if (i % 2 == 0) {
        // Admission type  if child is only admitted but not discharged before concerning date
        if (data[i + 1] != null && (data[i].dateOfAdmission!.toDate() <= this.startDate1) && (data[i + 1].dateOfDischarge!.toDate() >= this.startDate1)) {
          this.pCOUNT++
          this.pList.push(childCode + ' - ' + data[length - 1] + `(${i})`
          )
        }
        // Admission type  if child is only admitted but not discharged before concerning date
        if (data[i + 1] == null) {
          this.pCOUNT++
          this.pList.push(childCode + ' - ' + data[length - 1] + `(${i})`)

        }

        console.log('prevCount', this.pCOUNT)  // ? This is the total present child count

      }
    } catch (e) {
      console.error(childCode + `=${i}=>`, e)
    }
  }

  checkPreviousAdmissionNew(i: number, ad: AdmissionType, data: AdmissionType[], prevcount: number, childCode: string,centreCode:string) {


    try {
      if (i % 2 == 0  && ad.centreCode === centreCode ) {
        // Admission type  if child is only admitted but not discharged before concerning date
        if ( data[i + 1] != null && (data[i].dateOfAdmission!.toDate() <= this.startDate1) && data[i + 1].dateOfDischarge!.toDate() > this.startDate1 ) {
          this.pCOUNT++
          this.pList.push(childCode + ' - ' + data[length - 1] + `(${i})`)
        }
         // if there is no discharge after admission before concerned date
        if (data[i + 1] == null && (data[i].dateOfAdmission!.toDate() <= this.startDate1)) {
          this.pCOUNT++
          this.pList.push(childCode + ' - ' + data[length - 1] + `(${i})`)

        }

        console.log('prevCount', this.pCOUNT)  // ? This is the total present child count admitted on day 1

      }
    } catch (e) {
      console.error(childCode + `=${i}=>`, e)
    }
  }


  checkPreviousAdmission2(i: number, ad: AdmissionType, data: AdmissionType[], prevcount: number, childCode: string,centreCode:string) {

    try {
      if (i % 2 == 0 && ad.centreCode ==centreCode) {
        // Admission type  if child is only admitted but not discharged before concerning date
        if (data[i + 1] != null && (data[i].dateOfAdmission!.toDate() <= this.endDate1) && data[i + 1].dateOfDischarge!.toDate() >= this.endDate1) {
          this.pCOUNT2++
          this.pList2.push(childCode + ' - ' + data[length - 1] + `(${i})`)
        }
        // Admission type  if child is only admitted but not discharged before concerning date
        if (data[i + 1] == null && (data[i].dateOfAdmission!.toDate() <= this.endDate1)) {
          this.pCOUNT2++
          this.pList2.push(childCode + ' - ' + data[length - 1] + `(${i})`)

        }

        console.log('prevCount', this.pCOUNT2)  // ? This is the total present child count

      }
    } catch (e) {
      console.error(childCode + `=${i}=>`, e)
    }
  }


  exportexcel() {
    /* assessment-table id is passed over here */
    let element = document.getElementById('excel-table');

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    // Get the sheet range, or assume a default range if not available
    const range = ws['!ref'] ? XLSX.utils.decode_range(ws['!ref']) : {s: {r: 0, c: 0}, e: {r: 0, c: 0}};

    // Set cell format as percentage for the Occupancy column (for example, column C)
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell_address = {c: C, r: R};
        const cell_ref = XLSX.utils.encode_cell(cell_address);
        if (ws[cell_ref] && ws[cell_ref].v && C === 5 && R !== 0) { // Assuming Occupancy is the second column (C)
          ws[cell_ref].t = 'n'; // Set the cell type to 'n' (number)
          ws[cell_ref].z = '0.0%'; // Set the cell format to display as percentage with one decimal place
        }
      }
    }


    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  onEndDateChanged() {
    this.endDate1?.setHours(23, 59, 0, 0);
  }
  protected readonly Math = Math;
  protected readonly PermissionType = PermissionType;
}
